import { LocationTypeInfoData } from '../data/location_type_info_data.js';

const iconSize = { width: 18, height: 20 };

const AttributeTypes = {
  activities: {
    title: 'Activities',
    type: 'list',
  },
  amenities: {
    title: 'Amenities',
    type: 'list',
  },
  difficulty: {
    title: 'Difficulty',
    type: 'list',
  },
  facilities: {
    title: 'Facilities',
    type: 'list',
  },
  features: {
    title: 'Keywords',
    type: 'list',
  },
  fishing: {
    title: 'Fishing',
    type: 'list',
  },
  services: {
    title: 'Services',
    type: 'list',
  },
};

/**
 * Location type info.
 */
class LocationTypeInfo {
  static Data = LocationTypeInfoData;

  constructor({ type, subtype }) {
    this.#type = type;
    this.#subtype = subtype;

    this.#data = LocationTypeInfoData[type];
    if (!this.#data) {
      throw new Error(`No location info for '${type}' type`);
    }

    if (subtype && !(this.#data.subtypes instanceof Array)) {
      for (let subtypeName of Object.keys(this.#data.subtypes)) {
        let subtypeInfo = this.#data.subtypes[subtypeName];
        if (subtypeInfo.name == subtype) {
          this.#subtypeInfo = subtypeInfo;
          break;
        }
      }
    }
  }

  get type() {
    return this.#type;
  }

  get subtype() {
    return this.#subtype;
  }

  get name() {
    return this.#subtypeInfo.name ?? this.#data.name;
  }

  get category() {
    return this.#data.name;
  }

  get rels() {
    return this.#subtypeInfo.rels ?? this.#data.rels ?? [];
  }

  get attributes() {
    if (!this.#attributes) {
      this.#attributes = Object.assign(
        {},
        this.#subtypeInfo.attributes || this.#data.attributes
      );
      for (let attrName of Object.keys(this.#attributes)) {
        this.#attributes[attrName] = Object.assign(
          {
            values: this.#attributes[attrName],
          },
          AttributeTypes[attrName]
        );
      }
    }
    return this.#attributes;
  }

  get ratings() {
    return this.#subtypeInfo.ratings ?? this.#data.ratings;
  }

  get icon_url() {
    return this.#subtypeInfo.icon_url ?? this.#data.icon_url;
  }

  get mapicon() {
    let mapicon = this.#subtypeInfo.mapicon || this.#data.mapicon;
    if (mapicon) {
      return mapicon;
    }
    let url = this.#subtypeInfo.mapicon_url || this.#data.mapicon_url;
    return (
      url && {
        url,
        size: iconSize,
      }
    );
  }

  get mapicon_attention() {
    return {
      url: '/images/map-qm.png',
      size: { width: 24, height: 27 },
    };
  }

  get zoom() {
    return this.#subtypeInfo.zoom ?? this.#data.zoom;
  }

  canHaveRoute() {
    return this.#data.canHaveRoute;
  }

  isValid(loc) {
    return loc.type == this.#type && loc.subtype == this.#subtype;
  }

  #attributes;
  #data;
  #subtype;
  #subtypeInfo = {};
  #type;
}

export { LocationTypeInfo };
